import PropTypes from "prop-types"

import { PromoTag } from "./SaleTags"

function Pricing({ style, prices, currency, userIsVip, hideTag = false }) {
  const price = prices.lowest ? prices.lowest : prices.default

  const onSale = price.sale

  const differentLowestAndHighestPrices = () =>
    prices.lowest &&
    prices.highest &&
    Number.parseFloat(prices.lowest.price) !==
      Number.parseFloat(prices.highest.price)

  const getDisplayPrice = (symbol) => {
    if (differentLowestAndHighestPrices()) {
      return `${symbol}${prices.lowest.price} - ${symbol}${prices.highest.price}`
    }

    return `${symbol}${price.price}`
  }

  const displayPrice = getDisplayPrice(currency.symbol)

  /* const hasVipPrice = prices && prices.lowest && prices.lowest.discount_vip

  const vipPrice = hasVipPrice
    && (
      parseFloat(prices.lowest.price) - parseFloat(prices.lowest.discount_vip)
    ).toFixed(2)

  const vipActive = userIsVip && hasVipPrice

  if (vipActive) {
    displayPrice = vipPrice
  } */

  const tagStyle = { float: "right", height: 12 }

  return (
    <div style={{ textAlign: "right", marginRight: "-6px", ...style }}>
      <div
        className={`pr-[6px] flex flex-col ${hideTag ? "mb-0" : "mb-[8px]"}`}
      >
        <div className="font-500 m-0 p-0 text-[20px] leading-none whitespace-nowrap">
          {displayPrice}
        </div>
        <div className="font-400 m-0 p-0 text-[12px] leading-none">
          {onSale && price.price_original && (
            <span
              style={{
                textDecoration: "line-through",
                display: "inline-block",
                marginRight: "4px",
              }}
            >
              {currency.symbol}
              {price.price_original}
            </span>
          )}
          {currency.code}
        </div>
      </div>
      {/*
      {!hideTag && (vipPrice && !vipActive) && (
        <InactiveVipTag style={tagStyle} price={currency.symbol + vipPrice} />
      )}
      {!hideTag && vipActive && <VipTag style={tagStyle} />}
      */}
      {!hideTag && onSale && <PromoTag style={tagStyle} />}
    </div>
  )
}

Pricing.propTypes = {
  style: PropTypes.object,
  prices: PropTypes.object,
  currency: PropTypes.object,
  userIsVip: PropTypes.bool,
  hideTag: PropTypes.bool,
}

export default Pricing
